import React from 'react';
import { Grid, Container } from '@material-ui/core';
import styles from './style.module.scss';
import DefaultContainer from '../DefaultContainer';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import ImageContainer from '../ImageContainer';
import Image from '../Image';
import { wearePage } from '../../data';
import img1 from '../../assets/images/aboutus-1-min.webp';
import img2 from '../../assets/images/aboutus-2-min.webp';
import img3 from '../../assets/images/aboutus-3-min.webp';
import img4 from '../../assets/images/aboutus-4-min.webp';
import img1Fall from '../../assets/images/aboutus-1-min.png';
import img2Fall from '../../assets/images/aboutus-2-min.png';
import img3Fall from '../../assets/images/aboutus-3-min.png';
import img4Fall from '../../assets/images/aboutus-4-min.png';

const AboutUsSection = () => (
  <DefaultContainer
    justify="flex-start"
    direction="column"
    className={styles.container}
    noPadding
  >
    <Container>
      <Grid item>
        <HeadlineSmall>{wearePage.aboutUsHeadlineSmall}</HeadlineSmall>
        <HeadlineLarge
          stroke={wearePage.aboutUsStroke}
          className={styles.headlineLarge}
          medium
        >
          {wearePage.aboutUsHeadline}
        </HeadlineLarge>
      </Grid>
    </Container>
    <Grid
      container
      direction="column"
      className={styles.containerInner}
    >
      <Grid item>
        <ImageContainer justify="center" spacing={2}>
          <Grid item xs={12} sm={3}>
            <Image source={{ main: img1, fall: img1Fall }} alt="office we app" className={styles.imageAboutUs} />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Image source={{ main: img3, fall: img3Fall }} alt="office we app" className={styles.imageAboutUs} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Image source={{ main: img2, fall: img2Fall }} alt="office we app" className={styles.imageAboutUs} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Image source={{ main: img4, fall: img4Fall }} alt="office we app" className={styles.imageAboutUs} />
          </Grid>
        </ImageContainer>
      </Grid>
      <Grid item>
        <Container>
          <Grid container justify="flex-end">
            <Grid item sm={6}>
              <h4 className={styles.text}>
                {wearePage.aboutUsText}
              </h4>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </Grid>
  </DefaultContainer>
);

export default AboutUsSection;
